import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'movieType'
})
export class MovieTypePipe implements PipeTransform {

  transform(value: any[], args?: any): any {
    return value.toString() ;
  }

}
